module.exports = __webpack_public_path__ + "img/brgj.3d04c916.png";